import { CloudinaryImage } from "../../../../../Atoms/Cloudinary";
import styles from "./ProfileHeads.module.css";

const size = 32;

interface Props {
  guides: Array<{
    nickName: string | null;
    profilePic: string | null;
  }>;
}

export default function ProfileHeads({ guides }: Props) {
  const count = guides.length;
  const cssStyle = {
    height: size,
    width: (size * count) / 2 + size / 2,
  };

  return (
    <div className={styles.ProfileHeads} style={cssStyle}>
      <ul>
        {guides.map((g, index) => {
          if (!g.profilePic || !g.nickName) {
            return null;
          }

          return (
            <li
              key={index}
              style={{ left: index * (size / 2) }}
              title={g.nickName}
            >
              <div style={{ position: "relative", width: size, height: size }}>
                <CloudinaryImage
                  transformations={[`w_${size}`, `h_${size}`, "c_fill"]}
                  src={g.profilePic}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
